var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCircleFilled = function SvgPauseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.015 7.99a8 8 0 1 1-16 0 8 8 0 0 1 16 0M5 10.5a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0zm4 0a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgPauseCircleFilled;